module.exports = __webpack_public_path__ + "img/smartphone.c9d293c3.svg";